import { escapeHtml } from 'lib';
import { log } from 'lib/permalog';
import { domDialog } from 'lib/view';

function terseHref(): string {
  return window.location.href.replace(/^(https:\/\/)?(?:lichess|lichess1)\.org\//, '/');
}

export function addExceptionListeners() {
  window.addEventListener('error', async e => {
    const loc = e.filename ? ` - (${e.filename}:${e.lineno}:${e.colno})` : '';
    await log(`${terseHref()} - ${e.message}${loc}\n${e.error?.stack ?? ''}`.trim());
    if (site.debug)
      await domDialog({
        htmlText: escapeHtml(`${e.message}${loc}\n${e.error?.stack ?? ''}`),
        class: 'debug',
        easyClose: 'clickOutside',
        show: true,
      });
  });

  window.addEventListener('unhandledrejection', async e => {
    let reason = e.reason;
    if (typeof reason !== 'string')
      try {
        reason = JSON.stringify(e.reason);
      } catch (_) {
        reason = 'unhandled rejection, reason not a string';
      }
    await log(`${terseHref()} - ${reason}`);
    if (site.debug)
      await domDialog({
        htmlText: escapeHtml(reason),
        class: 'debug',
        easyClose: 'clickOutside',
        show: true,
      });
  });
}
